import { AxiosService } from './axios.service'

const baseURL = 'card-admin'

/**
 * Defines the API methods for an user ticket
 */
export class MuvicardAdminService {
	/**
	 * Get info card
	 * @return {Promise<any[]>}
	 */
	static SendResetPasswordEmail(userId) {
		// var dados = {
		// 	address: user
		// }
		return AxiosService.post(`${baseURL}/solicitar-alteracao-de-senha`, {
			userId,
		})
			.then(({ data }) => data)
			.catch(() => [])
	}

	static searchForCard(userId) {
		return AxiosService.post(`${baseURL}/buscar-cartao`, {
			userId,
		})
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Manual close invoice
	 */
	static closeBankslip(id) {
		return AxiosService.post(`${baseURL}/baixar-fatura/${id}`).then(
			({ data }) => data
		)
	}
	/**
	 * Manual approve proposal
	 */
	static approveManualProposal(id) {
		return AxiosService.post(`${baseURL}/aprovar-proposta/${id}`).then(
			({ data }) => data
		)
	}
}
